module.exports = __webpack_public_path__ + "img/insurita-experience-three.02c19f49.svg";